module.exports = __webpack_public_path__ + "src/app/images/convious-logo-pink.png?a81d0c1ec4a8c656e7848990a485fab8";